import _ from "lodash";
import moment from "moment";
import api from "@/service/epaper.js";

const state = {
  epaperList: [],
  letterList: {
    title: {
      title: "",
      inname: "",
      sendTime: moment().format("YYYY-MM-DD"),
      sync: false,
      style: "mail__style__1",
      backColor: "#eeeeee"
    },
    header: {
      title: "",
      image: "",
    },
    body: [{
      model: "",
      title: "",
      titleSub: "",
      dataList: [{
        delete: false,
        titleH1: "",
        titleH2: "",
        contentP: "",
        buttonName: "",
        buttonUrl: "",
        image: "",
        imageShow: ""
      }],
      delete: false
    }],
    footer: {
      title: "",
      dataList: [],
    }
  },
  defaultLetterList: {
    title: {
      title: "",
      inname: "",
      sendTime: moment().format("YYYY-MM-DD"),
      sync: false,
      style: "mail__style__1",
      backColor: "#eeeeee"
    },
    header: {
      title: "",
      image: "",
    },
    body: [{
      model: "",
      title: "",
      titleSub: "",
      dataList: [{
        delete: false,
        titleH1: "",
        titleH2: "",
        contentP: "",
        buttonName: "",
        buttonUrl: "",
        image: "",
        imageShow: ""
      }],
      delete: false
    }],
    footer: {
      title: "",
      dataList: [],
    }
  }
};
const getters = {}
const actions = {
  getEpaperList({
    state,
    commit
  }) {
    let result = api.getEpaperList();
    result.then((data) => {
      if (data.data.state) {
        commit("setEaperList", data.data.result);
      } else {
        commit("setEaperList", []);
      }
    });
    return result;
  },

  saveEpaper({
    state,
    commit
  }, data) {
    let result = api.saveEpaper(data);
    result.then((data) => {
      console.log(data);
    });
    return result;
  },

  getEpaper({
    state,
    commit
  }, uid) {
    if (uid == "insert") {
      let temp = JSON.parse(JSON.stringify(state.defaultLetterList));
      commit("setLetterList", temp);
    } else {
      let result = api.getEpaper(uid);
      result.then((data) => {
        if (data.data.state) {
          commit("setLetterList", data.data.result);
        }
      });
      return result;
    }
  }
};
const mutations = {
  setEaperList(state, data) {
    state.epaperList = data;
  },

  setLetterList(state, data) {
    const resultData = _.mapValues(data, (item, key) => {
      item.backColor = item.backColor ? item.backColor : "#eeeeee"
      return item;
    });

    state.letterList = resultData;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
